<section class="card-wide-section__section">
  @if (title) {
    <div class="card-wide-section__section-container">
      @if (!isFirstSection) {
        <h2 class="card-wide-section__title" [innerHTML]="title"></h2>
      }
      @if (isFirstSection) {
        <h1 class="card-wide-section__title" [innerHTML]="title"></h1>
      }
    </div>
  }
  <div
    class="card-wide-section__section-container card-wide-section__container--items"
  >
    @for (card of contents; track card) {
      <div class="card-wide-section__card-wrapper">
        <div class="card-wide-section__card">
          <div class="card-wide-section__card__content">
            @if (card.imgSrc) {
              <div class="card-wide-section__card__img">
                <img
                  [src]="card.imgSrc"
                  [alt]="card.title"
                  style="width: auto"
                />
              </div>
            }
            @if (card.description) {
              <div
                class="card-wide-section__card__description"
                [innerHTML]="card.description | unescape"
              ></div>
            }
            <div class="card-wide-section__card__titles-wrapper">
              @if (card.title) {
                <div
                  class="card-wide-section__card__title"
                  [innerHTML]="card.title"
                ></div>
              }
              @if (card.subtitle) {
                <div
                  class="card-wide-section__card__subtitle"
                  [innerHTML]="card.subtitle"
                ></div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</section>
